import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import ReverseSplitShareForm, {
  buildFractionShareAdjustments,
  DEFAULT_REVERSE_SPLIT_RATIO,
  ReverseSplitShare,
} from "./reverseSplitShareDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<ReverseSplitShare>,
  data?: ReverseSplitShare,
): ReverseSplitShareForm {
  return new ReverseSplitShareForm(dispatch, context, data);
}

export function applyForm(form: ReverseSplitShareForm): ReverseSplitShare {
  return {
    type: DecisionType.reverseSplitShare,
    ratio: form.ratio.toNumber() ?? DEFAULT_REVERSE_SPLIT_RATIO,
    shareCapitalParagraph: form.shareCapitalParagraph.selected,
    fractionAdjustment: form.fractionAdjustment,
    fractionAdjustmentName: form.fractionAdjustmentNameModel.value,
    fractionShareAdjustments: buildFractionShareAdjustments(
      form.reverseSplitShareOverview.shareholdersWithFraction,
    ),
  };
}

export function validate(form: ReverseSplitShareForm) {
  return form.validate();
}

export function isValid(form: ReverseSplitShareForm) {
  return form.isValid;
}

export const reverseSplitHandler: DecisionTypeHandler<
  DecisionType.reverseSplitShare,
  ReverseSplitShare,
  ReverseSplitShareForm
> = {
  type: DecisionType.reverseSplitShare,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent(form: ReverseSplitShareForm, event: DbotEvent) {
    form.handleEvent(event);
  },
};
